import socketService from "./socket.service";
var reportService;
(function (reportService) {
    reportService.sendReport = function (what, id) {
        return socketService.emit("reports.add", {
            what: what,
            id: id
        });
    };
})(reportService || (reportService = {}));
export default reportService;



//////////////////
// WEBPACK FOOTER
// ./js/services/report.service.ts
// module id = Zngv
// module chunks = 1